import React from 'react';
import decode from 'jwt-decode';
import { mountTable, unmountTable } from '../../views/Components/JQueryTable/JQueryTableLogic.jsx';
import JQueryTableComponent from '../../views/Components/JQueryTable/JQueryTableComponent.jsx';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import { API_ROOT } from '../../variables/api-config';
import ModalSolicitud from './ModalSolicitud.jsx';
import SweetAlert from "react-bootstrap-sweetalert";

const dataTable = {
  headerRow: ["Nro", "Solicitante", "Equipo", "Fecha Solicitud", "Dias", "Acciones"],
  footerRow: ["Nro", "Solicitante", "Equipo", "Fecha Solicitud", "Dias", "Acciones"],
};

class SolicitudTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: decode(localStorage.getItem('id_token')),
      currentSolicitud: null,
      alert: null,
    };
    this.onClickDevuelto = this.onClickDevuelto.bind(this);
    this.editAction = this.editAction.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.customAction = [
      {
        htmlString: '<button class="btn btn-fill btn-xs text-right"></button>',
        actionString: 'click',
        actionFunction: this.onClickDevuelto,
        equipmentList: null,
        disableMe: this.props.currentRole === 'Asistente Técnico de Gestión'
      }
    ];
    this.fixedColWidth = {
      col: 0,
      value: 1,
    }
  }
  componentWillMount() {
    this.props.administrationService.getEquipmentList(1)
      .then(res => {
        this.setState({equipmentList: res});
      })
      .catch(err => {
        this.props.errorAlert(
          <div>
            Ocurrio un error mientras se cargaban los datos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>);
      });
  }
  componentDidMount() {
    mountTable(API_ROOT + "/administration/equipment-request-grid", "solicitudTab", this.editAction, null, this.customAction, null, null, null, this.fixedColWidth, false);
  }
  componentWillUnmount() {
    unmountTable('solicitudTab');
  }
  shouldComponentUpdate() {
    return true;
  }
  onClickDevuelto(data){
    const devueltoEquipo = data[7].text === 'DEVUELTO' ? 0 : 1;
    this.props.confirmUpdate(data[0], data[6], devueltoEquipo);
  }

  showAlert() {
    this.setState({
      alert: (
        <SweetAlert
          error
          style={{ display: "block" }}
          title="No hay equipos disponibles!"
          onConfirm={() => this.setState({alert: null})}
          confirmBtnBsStyle="danger"
          confirmBtnText="Aceptar"
        >
          No se puede crear una nueva solicitud porque no hay equipos disponibles.
          Puede que no hayan equipos cargados o todos se encuentren ocupados por otras solicitudes.
        </SweetAlert>
      )
    });
  }

  editAction(data) {
    const solicitud = {
      solicitante: data[1],
      //equipo: {value: data[6], label: data[2]},
      equipo: JSON.parse(data[6]),
      dias: data[5],
      id: data[0],
    };
    this.setState({currentSolicitud: solicitud, modalOpen: true})
  }
  onCancel() {
    // Tuve que hacer esto por un error en el cancel donde se mutaba el array de dias por alguna razon en datatables
    this.setState({modalOpen: false, currentSolicitud: null});
  }
  render() {
    return(
      <div>
        {this.state.alert}
        {this.state.equipmentList && this.props.currentRole !== 'Administrador Sistema' &&
          <div>
            <div style={{ paddingBottom: "10px"}} className="visible-xs-block">
              <Button
                bsStyle="primary" bsSize="sm" fill wd block
                onClick={this.state.equipmentList.length === 0 ? () => this.showAlert() : () => this.setState({modalOpen: true})}
                >
                  Nueva Solicitud
              </Button>
            </div>
            <div style={{ textAlign: "right", paddingBottom: 5 }} className="hidden-xs">
              <Button
                bsStyle="primary" bsSize="sm" fill wd
                onClick={this.state.equipmentList.length === 0 ? () => this.showAlert() : () => this.setState({modalOpen: true})}
                >
                  Nueva Solicitud
              </Button>
            </div>
          </div>
        }
        <div className="fresh-datatables">
          <JQueryTableComponent dataTable={dataTable} identifier="solicitudTab" />
        </div>
        {this.state.modalOpen &&
          <ModalSolicitud
            userName={this.state.currentUser.username} closeModal={this.onCancel}
            saveSolicitud={this.props.saveSolicitud} equipmentList={this.state.equipmentList}
            solicitud={this.state.currentSolicitud}
          />
        }
      </div>
    );
  }
}

export default SolicitudTab;



// WEBPACK FOOTER //
// ./src/views/Administration/SolicitudTab.jsx